import { AgentCategory } from "~/shared/enums";
import type { AgentConfig } from "~/shared/types";
import { validateIsNotEmpty, validateUrl } from "~/utils/validation";

import AgentIcon from "./AgentIcon.vue";
import Icon from "./Icon.vue";

const config: AgentConfig = {
  name: "Clay",
  category: AgentCategory.SALES,
  icon: Icon,
  agentIcon: AgentIcon,
  color: "#40bafe",
  helpUrl: "https://help.dartai.com/en/articles/11726726-ai-account-research-agent",
  description: "Automate lead research, enrich prospect data, and turn cold outreach into warmer conversations",
  descriptionMarkdown: `## Overview

Integrate Dart with Clay to enable automated lead enrichment and intelligent task routing based on prospect data signals. Clay's waterfall enrichment ensures maximum data coverage while AI-powered workflows automatically prioritize and assign tasks based on lead scoring and buying intent.

The integration works by connecting Clay's enrichment engine with Dart's task management system. When new prospects are identified, Clay automatically enriches their profiles and triggers appropriate Dart tasks based on predefined criteria like company size, industry, or engagement signals.

## Features

- Automatic lead enrichment with 75+ data providers for comprehensive prospect profiles
- AI-powered lead scoring and prioritization based on buying signals
- Smart task creation and assignment based on enriched data attributes
- Waterfall enrichment to maximize data coverage and accuracy
- Real-time data synchronization between Clay tables and Dart tasks
- Custom workflow triggers based on intent data and company events

## Setup guide

1. Create or use existing Clay account
2. Copy [the template](https://app.clay.com/shared-table/share_0syufknJtwhwypUJJMy) into your Clay account
3. Copy the Clay webhook URL and add an Auth token from Clay
4. Navigate to Dart agents page
5. Paste your Clay webhook URL and auth token in respective fields
6. In Clay, edit the \`Send to Dart\` column and paste your Dart webhook URL into the \`Endpoint\` field
7. Assign sales research tasks to your Clay agent in any accessible dartboard`,

  configFields: [
    {
      key: "webhook",
      type: "text",
      label: "Clay webhook URL",
      placeholder: "Your Clay webhook URL",
      validate: validateUrl,
    },
    {
      key: "apiKey",
      type: "password",
      label: "Auth token",
      placeholder: "Your Clay auth token",
      validate: validateIsNotEmpty,
    },
    {
      type: "webhook",
      key: "webhook",
    },
  ],
};

export default config;
